<template>
    <div class="Administration">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;" class="demo-ruleForm">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="开始时间" prop="startTime">
                        <el-date-picker @change="startTime1" v-model="ruleForm.startTime" align="right" type="date"
                            placeholder="选择开始时间" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="结束时间" prop="endTime">
                        <el-date-picker @change="endTime1" v-model="ruleForm.endTime" align="right" type="date"
                            placeholder="选择结束时间" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="店铺" prop="sellerId">
                        <el-select v-model="ruleForm.sellerId" placeholder="请选择店铺" clearable filterable
                            @change="changeSelect" value-key="sellerId">
                            <el-option v-for="item in shop_stationList" :key="item.id" :label="item.shop_name"
                                :value="item.sellerId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="审核状态" prop="reviewStatus">
                        <el-select v-model="ruleForm.reviewStatus" placeholder="请选择审核状态" clearable filterable
                            @change="changeSelect" value-key="reviewStatus">
                            <el-option v-for="item in reviewStatusList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
                <div>
                    <span>币种：</span>
                    <span class="Detailedspan" v-for="(item, i) in currency" :key="i" @click="Choice(item.val)"
                        :class="{ active: ruleForm.currencyCode === item.val }">
                        {{ item.name }}
                    </span>
                </div>
                <el-col :span="5">
                    <el-form-item prop="searchInput">
                        <!-- <el-input v-model="ruleForm.searchInput" placeholder="全字段搜索" style="width: 70%;"></el-input> -->
                        <el-button type="primary" @click="getCreditCardIncomeList()">搜索</el-button>
                        <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-col :span="13" class="line-height4">
                <el-col :span="2">币种：</el-col>
                <el-col :span="20">
                    <span
                        class="Detailedspan"
                        v-for="(item, i) in currency"
                        :key="i"
                        @click="Choice(item.val)"
                        :class="{ active: Choicetype === item.val }"
                    >
                        {{ item.name }}
                    </span>
                </el-col>
            </el-col> -->
            <!-- <el-col :span="11"></el-col> -->
        </el-form>
        <el-row>
            <el-table :data="tableData" v-loading="load_data" :header-cell-style="headClass" border style="width: 100%"
                class="table-container">
                <el-table-column prop="settlementStartDate" label="结算开始时间" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.settlementStartDate }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="settlementEndDate" label="结算结束时间" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.settlementEndDate }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="付款时间" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.depositDate }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="店铺名称" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.shopName }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="sellerId" label="卖家Id" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.sellerId }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="totalAmount" label="总金额" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.totalAmount }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="currency" label="币种" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.currency }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="reviewStatus" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <el-tooltip :content="'审核状态'" placement="top">
                            <el-switch v-model="scope.row.reviewStatus" @change='setReviewStatus(scope)'
                                active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="reviewTime" label="审核时间" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.reviewTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.createTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="selectHistory(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="[20, 50, 100, 200]" :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </el-row>
        <el-dialog title="查看详情" :visible.sync="dialogVis" width="65%" top="2%">
            <el-table :data="infoList" border style="width: 100%">
                <el-table-column prop="marketplaceName" label="市场名称" align="center"></el-table-column>
                <el-table-column prop="orderId" label="订单Id" align="center"></el-table-column>
                <el-table-column prop="transactionType" label="交易类型" align="center"></el-table-column>
                <el-table-column prop="amountType" label="金额描述" align="center"></el-table-column>
                <el-table-column prop="amount" :label="'金额' + '(' + infoCurrency + ')'"
                    align="center"></el-table-column>
                <el-table-column prop="quantityPurchased" label="购买数量" align="center"></el-table-column>
                <el-table-column prop="postedDateTime" label="发布时间" align="center"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVis = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "Detailed",
    data() {
        return {
            headClass: this.common.headClass,
            Choicetype: "0",
            load_data: false,
            tableData: [],
            ruleForm: {
                sellerId: '',
                startTime: '',
                endTime: '',
                currencyCode: '',
                reviewStatus: ''
            },
            shop_stationList: [],
            reviewStatusList: [
                {
                    id: 0,
                    name: '未审核'
                },
                {
                    id: 1,
                    name: '已审核'
                }
            ],
            currency: [
                {
                    val: "",
                    name: "全部",
                },
                {
                    val: "USD",
                    name: "美元",
                },
                {
                    val: "EUR",
                    name: "欧元",
                },
                {
                    val: "GBP",
                    name: "英镑",
                },
                {
                    val: "JPY",
                    name: "日元",
                },
                {
                    val: "AUD",
                    name: "澳元",
                },
                {
                    val: "CAD",
                    name: "加元",
                },
                {
                    val: "SGD",
                    name: "新加坡元",
                },
                {
                    val: "INR",
                    name: "印尼盾（卢比）",
                },
            ],
            UserInfo: {},
            page: 1,
            size: 20,
            total: 0,
            exchangeRateList: {},
            shopIds: [],
            dialogVis: false,
            infoList: null,
            infoCurrency: null
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.$nextTick(() => {
            this.getExchangeRateList()
            this.getAllSellerAndCountry();
            this.getCreditCardIncomeList();
        })
    },
    methods: {
        selectHistory(val) {
            this.infoCurrency = val.currency
            var obj = {
                settlementId: val.settlementId,
            }
            ajaxPost(Baseurl + "amazonOrderSettlement/selectAmazonOrderSettlementDetails", obj).then(res => {
                if (res.data.code == 200) {
                    this.infoList = res.data.data
                    this.dialogVis = true
                }
            });
        },
        // 获取汇率列表
        getExchangeRateList() {
            ajaxPost(Baseurl + "rateController/getRate").then(res => {
                const { data: responseData } = res;
                if (responseData.code === 200) {
                    const { data } = responseData;
                    this.exchangeRateList = data;
                    // console.log("汇率数据：", this.exchangeRateList);
                }
            });
        },
        setReviewStatus(val) {
            var parameter = {
                ids: [val.row.id],
                reviewStatus: val.row.reviewStatus
            };
            ajaxPost(Baseurl + "amazonOrderSettlement/reviewAmazonOrderSettlementDetails", parameter).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.$message.success('审核状态修改成功!')
                    this.getCreditCardIncomeList()
                }
            });
        },
        getCreditCardIncomeList() {
            var parameter = {
                page: this.page,
                size: this.size,
                startTime: this.ruleForm.startTime,
                endtime: this.ruleForm.endTime,
                currency: this.ruleForm.currencyCode,
                sellerId: this.ruleForm.sellerId,
                companyId: this.UserInfo.company_id,
                reviewStatus: this.ruleForm.reviewStatus
            };
            this.load_data = true;
            ajaxPost(Baseurl + "amazonOrderSettlement/selectAmazonOrderSettlements", parameter).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.tableData = data.list;
                    this.total = data.total;
                    this.load_data = false;
                }
            });
        },
        async getAllSellerAndCountry() {
            const API = Baseurl + "sellerController/selectSpSellerByCompanyId";
            const { company_id } = this.UserInfo;
            const paramsData = { company_id: company_id };
            const {
                data: { code, data },
            } = await ajaxPost(API, paramsData);
            if (code === 200) {
                // const handleData = data.reduce((total, item) => [...total, ...item.map(key => key.countryMarks)], []);
                this.shop_stationList = data;
                if (this.shop_stationList.length) {
                    this.shopIds = this.shop_stationList.map(item => item.sellerId)
                    // this.ruleForm.sellerId = this.shopIds
                    this.getCreditCardIncomeList();
                }
            }
        },
        startTime1(val) {
            const d = new Date(val);
            if (isNaN(d.getTime())) {
                console.error('日期错误!', val);
                return;
            }
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const date = String(d.getDate()).padStart(2, '0');
            const datetime = `${year}-${month}-${date} 00:00:00`;
            this.ruleForm.startTime = datetime;
        },
        endTime1(val) {
            const d = new Date(val);
            if (isNaN(d.getTime())) {
                console.error('日期错误!', val);
                return;
            }
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const date = String(d.getDate()).padStart(2, '0');
            const datetime = `${year}-${month}-${date} 23:59:59`;
            this.ruleForm.endTime = datetime;
        },
        search() {
            //搜索
        },
        resetFprm(formName) {
            this.$refs[formName].resetFields();
            this.shopIds = this.shop_stationList.map(item => item.sellerId)
            this.getCreditCardIncomeList();
        },
        Choice(val) {
            this.ruleForm.currencyCode = val;
            // this.Choicetype = val;
        },
        handleSizeChange(val) {
            this.size = val
            this.getCreditCardIncomeList();
        },
        handleCurrentChange(val) {
            this.page = val
            this.getCreditCardIncomeList();
        },
        changeSelect(item) {
            this.shopIds = [item.sellerId]
        }
    },
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-collapse {
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
    }

    .el-collapse-item__header {
        border-bottom: 1px solid #fff;
    }

    .el-collapse-item__wrap {
        border-bottom: 1px solid #fff;
    }

    .el-collapse-item__content {
        padding-bottom: 0px;
    }
}

.line-height {
    line-height: 30px;
}

.line-height4 {
    line-height: 40px;
}

.Detailedspan {
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 4px;
    cursor: pointer;
}

.active {
    background-color: rgb(43, 110, 236);
    color: #fff;
}

.Administration {
    padding-bottom: 72px;
}

.pagination-container {
    width: 100%;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
        display: flex;
        justify-content: center;
    }
}

.table-container {
    margin-bottom: 20px;
    /* 根据分页组件的高度调整这个值 */
}
</style>